import * as React from 'react';

import { getWCFRoomPath } from './utils/AppUtils';
import { Splashscreen, splashscreenManager } from './views/global/misc/Splashscreen';

import { DEBUG_FAKE_APP, isReactNativeApp } from '@egr/xbox/app-api/AppDetection';
import { registerFakeFsApi } from '@egr/xbox/app-api/Filesystem/DebugBackend';
import { startInitialization, finishInitialization } from '@egr/xbox/app-api/Initialization';
import { pConServiceProvider } from '@egr/xbox/pcon-login-api/ServicesProvider';
import { loadScript } from '@egr/xbox/utils/Helper';
import { getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';
import { setupSentry } from '@egr/xbox/utils/errors/Error';
import { DEBUG_LOG_CONSOLE, Logger } from '@egr/xbox/utils/errors/Logger';
import { PersistentStore } from '@egr/xbox/utils/store/PersistentStore';

import { joinPath } from '@easterngraphics/wcf/modules/utils/string';

setupSentry();

if (DEBUG_FAKE_APP) {
    // fs debug api:
    registerFakeFsApi();
}

startInitialization();
if (getEnvBoolean('DEBUG_DISABLE_SPLASH_SCREEN')) {
    finishInitialization();
}

export const AppLoader: React.FC = () => {
    const [ component, setComponent ] = React.useState<React.FunctionComponentElement<{}>|null>(null);

    React.useEffect(
        (): void => {
            void (async (): Promise<void> => {
                splashscreenManager.startProgress();

                await pConServiceProvider.initialize();
                await PersistentStore.loadOnStart();
                if (DEBUG_LOG_CONSOLE && isReactNativeApp) {
                    const { nativeLog } = await import('@egr/xbox/app-api/AppAction');

                    Logger.addLogging((...args) => {
                        nativeLog(
                            'warn',
                            args.toString(),
                        );
                    }, 'warning');
                    Logger.addLogging((...args) => {
                        nativeLog(
                            'error',
                            args.toString(),
                        );
                    }, 'error');
                }

                // eslint-disable-next-line @typescript-eslint/dot-notation
                if (window['CSG'] == null) {
                    await loadScript(joinPath(getWCFRoomPath(''), 'libs', 'csg-js', 'csg.min.js'));
                }

                const { getApp } = await import('./renderApp');

                const RealApp: React.FC = await getApp();

                setComponent(React.createElement(RealApp));
            })();
        },
        [] // call only once
    );

    return (
        <React.Fragment>
            {component}
            <Splashscreen/>
        </React.Fragment>
    );
};